(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ahk-notify"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ahk-notify')) {
    customElements.define(
      'ahk-notify',
      class extends HTMLElement {
        connectedCallback() {
          // After a post, the page reloads on the form: bring the confirmation into view.
          const done = this.querySelector('.ahk-notify__done');
          if (done && /contact_posted=true/.test(location.search)) done.focus();
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              const variant = event?.data?.variant;
              if (!variant) return;
              this.hidden = variant.available;
              const v = this.querySelector('[data-ahk-notify-variant]');
              if (v) v.value = `${variant.title} (#${variant.id})`;
              const l = this.querySelector('[data-ahk-notify-link]');
              if (l) l.value = `${location.origin}${location.pathname}?variant=${variant.id}`;
            });
          }
        }

        disconnectedCallback() {
          this.unsubscribe?.();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ahk-product-reels"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ahk-reels')) {
    customElements.define(
      'ahk-reels',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.frame = this.querySelector('.ahk-reels__frame');
          this.addEventListener('click', (event) => {
            const item = event.target.closest('[data-code]');
            if (item) this.open(item);
            if (event.target.closest('[data-close]') || event.target === this.dialog) this.dialog.close();
          });
          // Fade on the right edge only while there is more to scroll.
          const list = this.querySelector('.ahk-reels__list');
          const edge = () => list.classList.toggle('is-end', list.scrollLeft + list.clientWidth >= list.scrollWidth - 4);
          list.addEventListener('scroll', edge, { passive: true });
          new ResizeObserver(edge).observe(list);
          // Stop the video when the dialog closes (Esc, button or backdrop).
          this.dialog.addEventListener('close', () => {
            this.frame.replaceChildren();
            this.opener?.focus();
          });
        }

        open(item) {
          this.opener = item;
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.instagram.com/reel/${encodeURIComponent(item.dataset.code)}/embed/`;
          iframe.title = item.querySelector('.ahk-reels__name')?.textContent.trim() || 'Instagram';
          iframe.loading = 'lazy';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          this.frame.replaceChildren(iframe);
          this.dialog.showModal();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ahk-product-set"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ahk-set')) {
    customElements.define(
      'ahk-set',
      class extends HTMLElement {
        connectedCallback() {
          const initial = this.querySelector('[data-ahk-set-variant]');
          try {
            this.render(JSON.parse(initial.textContent));
          } catch (e) {}
          // Dawn publishes every variant change with the new variant.
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              if (event?.data?.variant) this.render(event.data.variant);
            });
          }
        }

        disconnectedCallback() {
          this.unsubscribe?.();
        }

        // Store values read cleanly: "coupe-culotte-ajustable" → "culotte ajustable",
        // "Small" / "s" / "medium" / "XXL" → "S" / "S" / "M" / "2XL".
        pretty(value) {
          const v = String(value).trim();
          const sizes = { small: 'S', s: 'S', medium: 'M', m: 'M', large: 'L', l: 'L', xlarge: 'XL', xl: 'XL', xxl: '2XL', '2xl': '2XL' };
          const key = v.toLowerCase();
          if (sizes[key]) return sizes[key];
          return v.replace(/^coupe-/i, '').replace(/-/g, ' ');
        }

        render(variant) {
          const options = variant?.options || [];
          this.querySelectorAll('[data-positions]').forEach((el) => {
            const positions = el.dataset.positions ? el.dataset.positions.split(',').map(Number) : [];
            el.textContent = positions.map((i) => options[i]).filter(Boolean).map((v) => this.pretty(v)).join(' · ');
          });
          // Compact layout: sizes only (S, M, 2XL, 38…), colour and cut left out.
          const isSize = (v) => /^(\d?x{0,3}[sml]|xs|\d{2})$/i.test(v);
          this.querySelectorAll('[data-size-positions]').forEach((el) => {
            const positions = el.dataset.sizePositions ? el.dataset.sizePositions.split(',').map(Number) : [];
            el.textContent = positions.map((i) => options[i]).filter(Boolean).map((v) => this.pretty(v)).filter(isSize).join(' · ');
          });
          // Single piece: the card photo follows the chosen colour when the variant has its own.
          const src = variant?.featured_media?.preview_image?.src || variant?.featured_image?.src;
          const img = this.querySelector('img[data-self-img="false"]');
          if (img && src) {
            img.srcset = '';
            img.src = src + (src.includes('?') ? '&' : '?') + 'width=200';
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
